import { useState, useEffect, useRef } from 'react';
import { useUrlParams } from './services/params';
import send_img from './img/send-icon.png';
import wait_img from './img/wait.svg'
import logo_img from './img/logo.png'

const backend = process.env.REACT_APP_BACKEND

function App() {
  const urlParams = useUrlParams()
  const url = urlParams.get('url')

  const [editUrl, setEditUrl ] = useState(url)
  const [a, setA ] = useState()
  const [b, setB ] = useState()
  const [c, setC ] = useState()
  // const [content, setContent ] = useState()
  const [frameUrl,setFrameUrl ] = useState()
  const [isLoading, setIsLoading] = useState(true);

  const handleChange = (value) => {
    setEditUrl(value)
  }

  useEffect(() => {
    const fetchToken = async () => {
      if ( url ) {
        const params = new URLSearchParams({
          'url':editUrl
        })

        const response = await fetch(backend+'/token.php?'+params.toString());
        const data = await response.json();
        setA(parseInt(data[0]))
        setB(parseInt(data[1]))
        setC(parseInt(data[2]))
      }
    };
    fetchToken();
  }, []);

  const fetchPage = async (currentUrl, ct,cb,cc) => {
    try {
        const params = new URLSearchParams({
            a: ct,
            b: cb-ct-2*((cc-ct)/3),
            url: currentUrl
        });
        setFrameUrl(`${backend}/page.php?${params.toString()}`)
        /*
        const response = await fetch(`${backend}/page.php?${params.toString()}`);
        const data = await response.text();
        setContent(data);
        */
    } catch (error) {
        console.error("Fetch failed:", error);
    }
  }

  useEffect(() => {
    // Only proceed if we actually have the data
    if (!a) return;

    const timer = setTimeout(() => {
      fetchPage(url,(a+c/2)/2,b,c/2);
    }, 2000);

    // Cleanup: prevents memory leaks if component unmounts
    return () => clearTimeout(timer);
  }, [a,b,c,url]); // This runs whenever token or time changes

  const go = () => {
    if ( !editUrl ) {
      window.location.href = window.location.origin + window.location.pathname
    } else {
      const params = new URLSearchParams({
        'url':editUrl
      })
      window.location = '?'+params.toString()
    }
  }

  const iframeRef = useRef(null);

  const frameLoaded = () => {
    setIsLoading(false)
  }

  const [timestamp, setTimestamp] = useState(null);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.type === 'WIKIWIX_TIMESTAMP') {
        console.log("Captured Timestamp:", event.data.value);
        setTimestamp(event.data.value);
      }
    };

    window.addEventListener('message', handleMessage);
    
    // Clean up the listener when the component unmounts
    return () => window.removeEventListener('message', handleMessage);
  }, []);

/*
  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe && content) {
      const doc = iframe.contentDocument || iframe.contentWindow.document;
      doc.open();
      doc.write(content);
      doc.close();
    }
  }, [content]);
*/
  const appClass = url ? 'App' : 'App home'
  return (
    <div className={appClass}>
      {(!url)&&<div className="expand"/>}
      <h1><a href="./"><img src={logo_img}/></a></h1>
      <p className="explain">{timestamp ? <>Archive du {new Date(timestamp*1000).toLocaleDateString()}</> : <>Tapez une URL pour consulter sa version archivée</>}</p>

      <form onSubmit={(e)=>{e.preventDefault();go()}}>
        <p className="url">
          <input type="text" value={editUrl} onChange={(e)=>handleChange(e.target.value)}/>
          <img src={send_img} className="button" onClick={go}/>
        </p>
      </form>
      {( ( url&&isLoading) && <div className="loader"><p className="loader">
      Merci de patienter quelques secondes - nous recherchons une version archivée de cette page
      <br/>
      <img src={wait_img}/>
      </p></div> ) }
      { frameUrl &&
      <div className="content">
        <iframe
          ref={iframeRef}
          src={frameUrl}
          onLoad={() => frameLoaded()}
        />
      </div>
      }
    </div>
  );
}

export default App;
